<his-documentation-link
	[target]="moduleOptions.DOCUMENTATION_ARTICLE"
	[title]="moduleOptions.DOCUMENTATION_TITLE">
</his-documentation-link>
<div *ngIf="researchInfrastructure.id; else new">
   	<h1>{{'fs.res.researchInfrastructure.ResearchInfrastructure.edit' | hisUi}}</h1>
</div>
<ng-template #new><h1>{{'fs.res.researchInfrastructure.ResearchInfrastructure.create' | hisUi}}</h1></ng-template>

<his-dialog-header [showBackButton]="showBackButton" [showSearchButton]="showSearchButton" (save)="saveResearchinfrastructure()" (resetInputs)="reset()"></his-dialog-header>
<br/>

<p-tabView (onChange)="onTabIndexChange($event)" [activeIndex]="selectedIndex">
	<ng-container *ngFor="let tab of tabMenuItems; let i = index">
		<ng-container *ngIf="!tab.isDynamic; else dynamicTab">
		    <p-tabPanel lazy="true" [selected]="i === selectedIndex" [header]="tab.i18nKey|hisUi">
		        <res-info-panel [i18nKey]="tab.i18nKey" [target]="'researchInfrastructure'"></res-info-panel>
		        <ng-template pTemplate="header">
		        	<span class="p-tabview-title">{{ tab.i18nKey | hisUi }}</span>
		        </ng-template>
		        <!-- basic-data -->
		        <div *ngIf="tab.i18nKey === 'fs.res.common.mainData'">
					<res-research-infrastructure-data-tab [researchInfrastructure]="researchInfrastructure"
						[hisDynamicContent]="'fs.res.common.mainData'" [dynamicComponent]="researchInfrastructure._dynamicComponent">
					</res-research-infrastructure-data-tab>
				</div>
				<!-- advanced-data -->
				<div *ngIf="tab.i18nKey === 'fs.res.researchInfrastructure.ResearchInfrastructure.usage'">
					<res-research-infrastructure-usage-tab [researchInfrastructure]="researchInfrastructure" [usageTypes]="usageTypes"
						[hisDynamicContent]="'fs.res.researchInfrastructure.ResearchInfrastructure.usage'" [dynamicComponent]="researchInfrastructure._dynamicComponent">
					</res-research-infrastructure-usage-tab>
				</div>
				<!-- classification -->
				<div *ngIf="tab.i18nKey === 'fs.res.common.research'">
				<res-research-infrastructure-edit-research-results-tab
					[researchInfrastructure]="researchInfrastructure" (routerContextChange)="onRouterContextChange()"
					[hisDynamicContent]="'fs.res.common.research'" [dynamicComponent]="researchInfrastructure._dynamicComponent">
				</res-research-infrastructure-edit-research-results-tab>
				</div>
		    </p-tabPanel>

	    </ng-container>

	    <ng-template #dynamicTab>
			<p-tabPanel lazy="true" [selected]="i === selectedIndex" *ngIf="hisBaseGlobalsService.isAnyModuleActive('HISINONERES')" [header]="tab.i18nKey|hisUi">
			 	<ng-template pTemplate="header">
		        	<span class="p-tabview-title">{{ tab.i18nKey | hisUi }}</span>
		        </ng-template>
		        <res-dynamic-tab-container
                    [objectDynamicContent]="researchInfrastructure"
                    [hisDynamicContent]="tab.i18nKey"
                    [reloadTrigger]="reloadTrigger"
                    [dynamicComponent]="researchInfrastructure._dynamicComponent"
                    [target]="'researchInfrastructure'">
                </res-dynamic-tab-container>
			 </p-tabPanel>
	    </ng-template>
    </ng-container>
</p-tabView>
